<template>
   <v-card outlined class="corp-exp-card">
      <v-card-title class="corp-exp-title">
         <div>
            <div>Corporate Experience Summary</div>
            <div class="corp-exp-subtitle">For Corporate Member application only</div>
         </div>
         <v-spacer></v-spacer>
         <v-chip v-if="readonly" small color="blue-grey darken-2" dark>Review only</v-chip>
      </v-card-title>
      <v-card-text>
         Applicants summary experience is to be listed here. These experience shall at the minimum demonstrate at least
         six months full time equivalent experience for at least three of the following scope of planning works.
         Please indicate the period of full time experience and details of this summary should be authorised in the MIP log sheet.
         (All log sheet must be verified by the employer/supervisor who is a corporate member of MIP).
      </v-card-text>
      <v-card-text>
         <v-simple-table dense>
            <template v-slot:default>
               <thead>
                  <tr class="grey darken-1">
                     <th class="text-left" width="40"><div class="text-white">NO.</div></th>
                     <th class="text-left" width="350">
                        <div class="text-white">
                           SCOPE
                           <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                 <v-icon v-bind="attrs" v-on="on" color="yellow lighten-2">mdi-help-rhombus</v-icon>
                              </template>
                              <span>SCOPE OF PLANNING WORKS</span>
                           </v-tooltip>
                        </div>
                     </th>
                     <th class="text-left">
                        <div class="text-white">
                           DESCRIPTION
                           <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                 <v-icon v-bind="attrs" v-on="on" color="yellow lighten-2">mdi-help-rhombus</v-icon>
                              </template>
                              <span>BRIEF DESCRIPTION OF EXPERIENCE</span>
                           </v-tooltip>
                        </div>
                     </th>
                     <th class="text-left" width="200">
                        <div class="text-white">
                           EXPERIENCE
                           <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                 <v-icon v-bind="attrs" v-on="on" color="yellow lighten-2">mdi-help-rhombus</v-icon>
                              </template>
                              <span>PERIOD OF FULL-TIME EQUIVALENT EXPERIENCE IN MONTHS OR YEARS</span>
                           </v-tooltip>
                        </div>
                     </th>
                  </tr>
               </thead>
               <tbody>
                  <tr
                     v-for="item in datalist"
                     :key="item.expid"
                     class="border grey lighten-4"
                  >
                     <td class="border align-top pt-2">{{ item.expid }}</td>
                     <td class="border align-top pt-2">{{ item.scopeofwork }}</td>
                     <td class="border align-top">
                        <div v-if="readonly" class="readonly-cell">{{ item.description || '-' }}</div>
                        <v-textarea v-else auto-grow outlined rows="1" row-height="15" v-model="item.description" dense solo style="font-size: 10pt;"></v-textarea>
                     </td>
                     <td class="border align-top">
                        <div v-if="readonly" class="readonly-cell">{{ item.fulltimeperiod || '-' }}</div>
                        <v-textarea v-else auto-grow outlined rows="1" row-height="15" v-model="item.fulltimeperiod" dense solo style="font-size: 10pt;"></v-textarea>
                     </td>
                  </tr>
               </tbody>
            </template>
         </v-simple-table>
      </v-card-text>
      <v-card-actions v-if="!readonly">
         <v-spacer></v-spacer>
         <v-btn color="primary" @click="update">
            Update Summary Experience
         </v-btn>
      </v-card-actions>
      <v-divider></v-divider>
      <v-card-title>Log Sheet</v-card-title>
      <v-card-text>
         <p v-if="!readonly">
            You can download the Log Sheet template
            <a href="https://mip.org.my/wp-content/uploads/2020/03/Forms-002-Log-Sheet-Form.pdf" target="_blank" rel="noopener">here.</a>
         </p>
         <v-alert v-if="!readonly" type="info" dense text>
            Please upload the completed Log Sheet using the MIP template. Minimum requirement: 3 completed experience scopes and 1 verified log sheet.
         </v-alert>
         <div v-if="!readonly" class="d-flex">
            <v-file-input show-size accept=".doc,.docx,application/msword,.pdf" label="Upload File" v-model="uploadfile" dense solo class="mr-3"></v-file-input>
            <v-btn color="primary" :disabled="uploading || (!uploadfile)" @click="uploadlogsheet">
               Upload Log Sheet
            </v-btn>
         </div>
         <div class="d-flex">
            <v-text-field v-model="document" label="Uploaded Log Sheet" readonly class="mr-3" dense solo></v-text-field>
            <v-btn color="primary" :disabled="!document || !documentpath" @click="openview('/' + documentpath + '/' + document)">
               View File
            </v-btn>
         </div>
         <v-alert v-if="readonly && (!document || !documentpath)" type="warning" dense text>
            No log sheet uploaded.
         </v-alert>
      </v-card-text>
   </v-card>
</template>

<script>
const axios = require('axios')

export default {
   name: 'TableCorpExp',
   props: {
      readonly: {
         type: Boolean,
         default: false,
      },
   },
   components: {

   },

   data() {
      return {
         userid: 0,
         deflist: [
            { itemid: 0, expid: 1, scopeofwork: 'Development Control', description: '', fulltimeperiod: '', document: '', documentpath: ''},
            { itemid: 0, expid: 2, scopeofwork: 'Development Plans (Structure Plans & Local Plans etc).', description: '', fulltimeperiod: '', document: '', documentpath: ''},
            { itemid: 0, expid: 3, scopeofwork: 'Site Planning & Layout Preparation for Planning Permission', description: '', fulltimeperiod: '', document: '', documentpath: ''},
            { itemid: 0, expid: 4, scopeofwork: 'Special Studies or Report Preparation (LCP or inputs) EIA, SIA or TIA etc.', description: '', fulltimeperiod: '', document: '', documentpath: ''},
            { itemid: 0, expid: 5, scopeofwork: 'Research & Development', description: '', fulltimeperiod: '', document: '', documentpath: ''},
            { itemid: 0, expid: 6, scopeofwork: 'Teaching', description: '', fulltimeperiod: '', document: '', documentpath: ''},
            { itemid: 0, expid: 7, scopeofwork: 'Administration', description: '', fulltimeperiod: '', document: '', documentpath: ''},
            { itemid: 0, expid: 8, scopeofwork: 'Project Management & Feasibility Studies', description: '', fulltimeperiod: '', document: '', documentpath: ''},
            { itemid: 0, expid: 9, scopeofwork: 'Advocacy/Expert Witness', description: '', fulltimeperiod: '', document: '', documentpath: ''},
         ],
         datalist: [],
         isempty: true,
         uploadfile: null,
         document: '',
         documentpath: '',
         uploading: false,
      }
   },

   methods: {

      setuserid(pUserID) {
         this.userid = pUserID
         this.initialize()
      },

      initialize() {
         this.$nextTick(() => {
            this.loadgrid()
            this.loadlogsheet()
         })
      },

      checkCompleted() {
         const hasSummary = !this.isempty && this.datalist.filter(item => String(item.description || '').trim() !== '' && String(item.fulltimeperiod || '').trim() !== '').length >= 3
         const hasLogSheet = this.document !== '' && this.documentpath !== ''
         this.$emit('CorpExpStatus', { hasSummary, hasLogSheet })
         if (hasSummary && hasLogSheet) {
            this.$emit('CorpExpCompleted')
         }
      },

      loadgrid() {
         var targetPath = ''
         if (this.userid !== 0) {
            targetPath = '/member/empcorpexp/list/' + this.userid // get id from property
         } else {
            targetPath = '/member/empcorpexp/list' // get id from current login session (server-side)
         }
         axios.get(targetPath)
         .then((resp) => {
            if (resp.data) {
               var rtn = resp.data
               if (rtn.status === 'OK') {
                  if (rtn.data.length > 0) {
                     this.datalist = rtn.data
                     this.isempty = false
                     this.checkCompleted()
                  } else {
                     this.datalist = this.deflist
                     this.isempty = true
                     this.checkCompleted()
                  }
               } else {
                  console.log(rtn.status + ': ' + rtn.error)
               }
            }
         })
      },

      loadlogsheet() {
         var targetPath = ''
         if (this.userid !== 0) {
            targetPath = '/member/empcorpexp/logsheet/' + this.userid // get id from property
         } else {
            targetPath = '/member/empcorpexp/logsheet' // get id from current login session (server-side)
         }
         axios.get(targetPath)
         .then((resp) => {
            if (resp.data) {
               var rtn = resp.data
               if (rtn.status === 'OK') {
                  this.document = rtn.data ? (rtn.data.document || '') : ''
                  this.documentpath = rtn.data ? (rtn.data.documentpath || '') : ''
                  this.checkCompleted()
               } else {
                  this.document = ''
                  this.documentpath = ''
                  this.checkCompleted()
                  console.log(rtn.status + ': ' + rtn.error)
               }
            }
         })
      },

      uploadlogsheet() {
         var targetPath = '/member/empcorpexp/uploadlog'
         var data = new FormData()

         data.append('userid', this.userid)
         if (this.uploadfile) {
            data.append('document', this.uploadfile)
         }

         this.uploading = true
         axios.post(targetPath, data, {
            headers: {
               'Content-Type': 'multipart/form-data'
            }
         })
         .then((resp) => {
            this.uploading = false
            if (resp.data) {
               var rtn = resp.data
               if (rtn.status === 'OK') {
                  this.uploadfile = null
                  this.initialize()
                  this.checkCompleted()
               } else {
                  console.log(rtn.status + ': ' + rtn.error)
               }
            }
         })
      },

      update() {
         var targetPath = ''
         var data = {
            userid: this.userid,
            datalist: JSON.stringify(this.datalist) // passing array
         }

         if (this.isempty) {
            targetPath = '/member/empcorpexp/add'
         } else {
            targetPath = '/member/empcorpexp/update'
         }

         axios.post(targetPath, data, {
            headers: {
               'Content-Type': 'application/json' // must use this one coz passing array
            }
         })
         .then((resp) => {
            if (resp.data) {
               var rtn = resp.data
               if (rtn.status === 'OK') {
                  this.initialize()
                  this.checkCompleted()
               } else {
                  console.log(rtn.status + ': ' + rtn.error)
               }
            }
         })
      },

      openview(pUrl) {
         window.open(pUrl)
      },

   },

   mounted() {
      this.$emit('CorpExpMounted')
   },

}
</script>

<style scoped>
.corp-exp-card {
   border-radius: 6px;
}

.corp-exp-title {
   align-items: center;
   border-bottom: 1px solid #e5e7eb;
}

.corp-exp-subtitle {
   color: #64748b;
   font-size: 12px;
   font-weight: 400;
   margin-top: 2px;
}

.readonly-cell {
   color: #0f172a;
   line-height: 1.45;
   min-height: 36px;
   padding: 10px 12px;
   white-space: pre-line;
}
</style>
